<template>
  <div :id="model.sn" class="certificate">
    <div class="moduleName">
      <p>{{ model.title }}</p>
    </div>
    <span class="date">Bodyswaps</span>
    <span v-if="model.completed" class="userName">{{ $t('certificate.completed-by') }}<br><em>{{ model.userName }}</em><br>{{ formatDate(model.completed) }}</span>
    <span v-if="!model.completed" class="userName">Still in progress</span>
  </div>
</template>

<script>
  import moment from 'moment'
  
  
  export default {
    name: 'CertificateBadge',
    
    props: {
      model: {
        type: Object,
        required: false,
        default () {
          return { 
            sn: '1',
            module: 'module', 
            completed: true, 
            displayName: 'name',
          }
        },
      },
    },

    data () { 
      return {
        show: false, 
      }
    },
    
    methods: { 
      formatDate (timestamp) {
        return moment(timestamp).format('DD/MM/YYYY')
      },
    },
  }

</script>

<style scoped>

.container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 1rem;
}

.certificate {
  position: relative;
  align-items: center;
  width: 600px;
  height: 600px;
  background-image: url('~@/assets/badge.png');
  background-position-x: center;
  background-position-y: top;
}

.certificate span {
  width: 100%;
  position: absolute;
  text-align: center;
  font-size: 140%;
  line-height: 140%;
  vertical-align: middle;
  order: 1;
  color: white;
}

.certificate .moduleName {
  position: absolute;
  left: 0;
  right: 0;
  top: 37%;
  width: 68%;
  height: 12%;
  color: rgb(255, 255, 255);
  padding: 0;
  font-size: 2.0em;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  line-height: 30px;
}

.moduleName p {
  display: inline-block;
  vertical-align: middle;
  font-size: 100%;
}

.links {
  position: relative;
  width: 100%;
  text-align: center;
}



.userName {
  top: 52%;
}

.serialNumber {
  top: 60%;
  color: #90b1ce
}

.center {
  margin: 0 auto;
}

.date {
  top: 28%;
}

.dark {
  background-color: #192e40;
  color: white;
}
</style>
